import { Box } from "@mui/material";

// ─────────────────────────────────────────────────────────────────────────────
// CheckboxIcons — gradient-filled checkbox icons for the brand
// ─────────────────────────────────────────────────────────────────────────────
//
// MUI's default <Checkbox> uses SVG icons whose color is driven by the
// `color` prop (a single value, no gradient support). To get the brand
// teal-to-blue gradient as the checked fill, we provide custom icon
// components that render a styled Box with `background: var(--coapp-gradient-primary)`
// and an inline white check (or dash) inside.
//
// Wired into MuiCheckbox via defaultProps in theme.js so EVERY <Checkbox>
// in the app picks them up automatically — no per-instance override needed.
// ─────────────────────────────────────────────────────────────────────────────

const ICON_SIZE = 18;

export const UncheckedIcon = () => (
	<Box
		sx={{
			width: ICON_SIZE,
			height: ICON_SIZE,
			borderRadius: "5px",
			border: "1.5px solid rgba(13, 31, 48, 0.22)",
			background: "#FFFFFF",
			boxSizing: "border-box",
			transition: "border-color var(--coapp-motion-default, 0.18s ease)",
			".MuiCheckbox-root:hover &": {
				borderColor: "rgba(2, 213, 171, 0.55)"
			}
		}}
	/>
);

export const CheckedIcon = () => (
	<Box
		sx={{
			width: ICON_SIZE,
			height: ICON_SIZE,
			borderRadius: "5px",
			background: "var(--coapp-gradient-primary, linear-gradient(135deg, #02D5AB 0%, #0A7FA8 100%))",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			boxShadow: "0 1px 3px rgba(2, 213, 171, 0.32), inset 0 0 0 1px rgba(255, 255, 255, 0.18)",
			boxSizing: "border-box"
		}}
	>
		<svg width="12" height="9" viewBox="0 0 12 9" fill="none" aria-hidden="true">
			<path
				d="M1 4.5L4.3 7.8L11 1.1"
				stroke="white"
				strokeWidth="1.8"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</Box>
);

export const IndeterminateIcon = () => (
	<Box
		sx={{
			width: ICON_SIZE,
			height: ICON_SIZE,
			borderRadius: "5px",
			background: "var(--coapp-gradient-primary, linear-gradient(135deg, #02D5AB 0%, #0A7FA8 100%))",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			boxShadow: "0 1px 3px rgba(2, 213, 171, 0.32), inset 0 0 0 1px rgba(255, 255, 255, 0.18)",
			boxSizing: "border-box"
		}}
	>
		<Box sx={{ width: 10, height: 2, background: "#FFFFFF", borderRadius: 0.5 }} />
	</Box>
);
